export default "__VITE_ASSET__CzEyn_02__"